module.exports = __webpack_public_path__ + "static/media/donation.de459d28.svg";